module.exports = __webpack_public_path__ + "img/keder_karminrot_ral3002.476638cc.jpg";